import { prefixerM } from './common'

export const ROUTE_PPG_PRODUCTOBASE = prefixerM('producto-base')
export const ROUTE_PPG_NIVELAPROBACIONPRODUCTO = prefixerM('nivel-aprobacion-producto')
export const ROUTE_PPG_NIVELAPROBACIONOP = prefixerM('nivel-aprobacion-op')
export const ROUTE_PPG_ALERTACORREO = prefixerM('alerta-correo')
export const ROUTE_PPG_COSTOPROCESO = prefixerM('costo-proceso')
